import { Hidden } from "@mui/material";
import React, { Fragment, useState, useEffect } from "react";
import { Grid, Typography, Paper } from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import InboxIcon from "@mui/icons-material/Inbox";
import DraftsIcon from "@mui/icons-material/Drafts";
import { Link } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import {
  API_URL,
  MAIN_TITLE,
  DOMAIN_URL,
  SIDEBAR,
  ONLYLOGO,
  APPBAR,
  loadMessages,
} from "../actions/auth";
import clsx from "clsx";
import moment from "moment";
import { useTheme } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MailIcon from "@mui/icons-material/Mail";
import { useSelector, useDispatch } from "react-redux";
import AccountCircle from "@mui/icons-material/AccountCircle";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MoreIcon from "@mui/icons-material/MoreVert";
import Badge from "@mui/material/Badge";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import DashboardIcon from "@mui/icons-material/Dashboard";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import MessageIcon from "@mui/icons-material/Message";
import RestoreIcon from "@mui/icons-material/Restore";
import { loadUser, login } from "../actions/auth";
import ClassIcon from "@mui/icons-material/Class";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import SettingsIcon from "@mui/icons-material/Settings";
import SchoolIcon from "@mui/icons-material/School";
import DateRangeIcon from "@mui/icons-material/DateRange";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import Snackbar from "@mui/material/Snackbar";
import Card from "@mui/material/Card";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import { logout } from "../actions/auth";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import ListItemButton from "@mui/material/ListItemButton";
import MenuIcon from "@mui/icons-material/Menu";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import ThumbsUpDownIcon from "@mui/icons-material/ThumbsUpDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router";
import Button from "@mui/material/Button";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DeleteIcon from "@mui/icons-material/Delete";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Tooltip from "@mui/material/Tooltip";
import InventoryIcon from "@mui/icons-material/Inventory";
import Slide from "@mui/material/Slide";
import { getNotifications } from "../actions/auth";
import { themeStyle } from "../components/Components";
import { VOCAB } from "../components/Vocabulary";
import AddBoxIcon from "@mui/icons-material/AddBox";
import ListAltIcon from "@mui/icons-material/ListAlt";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import MergeIcon from "@mui/icons-material/Merge";
import DepartureBoardIcon from "@mui/icons-material/DepartureBoard";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import ViewTimelineIcon from "@mui/icons-material/ViewTimeline";
import {
  Person, // Students
  SupervisorAccount, // Teachers
  Class, // Classes
  Shuffle, // Shuffle
  Groups,
} from "@mui/icons-material";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
const drawerWidth = 300;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  backgroundColor: "white",
  color: themeStyle.primaryColor,
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    // marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& a": {
    color: themeStyle.primaryColor,
    textDecoration: "none",
    fontWeight: "bold",
    fontSize: "30px",
    "&:hover": {
      textDecoration: "none",
    },
  },

  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

function Sidebar(props) {
  const [showSnack, setShowSnack] = useState(false);
  const [snack, setSnack] = useState("");
  const [showSnack2, setShowSnack2] = useState(false);
  const [snack2, setSnack2] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const params = new URLSearchParams(window.location.search);
  const state = useSelector((state) => state);

  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [openFeedback, setOpenFeedback] = useState(false);
  const [openError, setOpenError] = useState(false);

  const [randomText, setRandom] = useState(makeid(4));

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const [anchorE2, setAnchorE2] = useState(null);

  const isMenuOpen = Boolean(anchorEl);
  const isNotificationsOpen = Boolean(anchorE2);

  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const [audio, setAudio] = useState(
    new Audio(require("../sounds/notification.mp3")),
  );
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleNotificationsMenuOpen = (event) => {
    setAnchorE2(event.currentTarget);
  };

  const handleNotificationsClose = () => {
    setAnchorE2(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const config = {
    headers: {
      Authorization: state.auth.token,

      "Content-Type": "application/json",
    },
  };

  function _retrieveData() {
    try {
      var installDate = localStorage.getItem("installDate");
      if (installDate == null) {
        _storeData();
      } else if (moment(installDate, "DD-MM-YYYY").diff(moment(), "days") > 3) {
        _storeData();
        setOpenError(true);
      }
    } catch (error) {
      console.log(error);
    }
  }

  function _retrieveData2() {
    try {
      var installDate = localStorage.getItem("installDate");
      if (installDate == null) {
        _storeData();
      } else if (moment(installDate, "DD-MM-YYYY").diff(moment(), "days") > 7) {
        _storeData();
        setOpenFeedback(true);
      }
    } catch (error) {
      console.log(error);
    }
  }

  function _storeData() {
    localStorage.setItem(
      "installDate",
      new moment().format("DD-MM-YYYY").toString(),
    );
  }

  useEffect(() => {
    _retrieveData();
    _retrieveData2();
    dispatch(getNotifications());
    audio.load();
  }, []);

  function playAudio() {
    const audioPromise = audio.play();
    if (audioPromise !== undefined) {
      audioPromise
        .then((_) => {
          // autoplay started
        })
        .catch((err) => {
          // catch dom exception
          console.info(err);
        });
    }
  }

  function updateNotificationSeen(notification_id) {
    var body = {
      user_id: state.auth.user.user_id,
      notification_id: notification_id,
    };
    body = JSON.stringify(body);
    axios
      .post(API_URL + "/update_notification_seen", body, config)
      .then((res) => {
        getNotifications();
      });
  }

  function clearAllNotifications() {
    var body = {
      user_id: state.auth.user.user_id,
      notifications: state.auth.notifications,
    };
    body = JSON.stringify(body);
    axios
      .post(API_URL + "/clear_all_notifications", body, config)
      .then((res) => {
        dispatch(getNotifications());
      });
  }

  var name;
  switch (window.location.pathname) {
    case "/":
      name = "Dashboard";
      break;
    case "/dashboard":
      if (state.auth.user.is_student) {
        name = VOCAB[state.auth.language]["pages"]["STUDENT_DASHBOARD"];
      } else if (state.auth.user.is_teacher) {
        name = VOCAB[state.auth.language]["pages"]["TEACHER_DASHBOARD"];
      } else if (state.auth.user.is_onboarding) {
        name = VOCAB[state.auth.language]["pages"]["ONBOARDING_DASHBOARD"];
      } else if (state.auth.user.is_billing) {
        name = VOCAB[state.auth.language]["pages"]["BILLING_DASHBOARD"];
      } else if (state.auth.user.is_parent) {
        name = VOCAB[state.auth.language]["pages"]["PARENT_DASHBOARD"];
      } else if (state.auth.user.is_inventory) {
        name = VOCAB[state.auth.language]["pages"]["INVENTORY_DASHBOARD"];
      } else if (state.auth.user.is_transport) {
        name = VOCAB[state.auth.language]["pages"]["TRANSPORT_DASHBOARD"];
      } else if (state.auth.user.is_principal) {
        name = VOCAB[state.auth.language]["pages"]["PRINCIPAL_DASHBOARD"];
      }
      break;
    case "/classes":
      name = VOCAB[state.auth.language]["pages"]["CLASSES"];
      break;
    case "/inventory_principal":
      name = VOCAB[state.auth.language]["pages"]["INVENTORY"];
      break;
    case "/staff":
      name = VOCAB[state.auth.language]["pages"]["STAFF"];
      break;
    case "/fee-collection":
      name = VOCAB[state.auth.language]["pages"]["FEE_COLLECTION"];
      break;
    case "/add-fees":
      name = VOCAB[state.auth.language]["pages"]["ADD_FEES"];
      break;
    case "/students":
      name = VOCAB[state.auth.language]["pages"]["STUDENTS"];
      break;
    case "/teachers":
      name = VOCAB[state.auth.language]["pages"]["TEACHERS"];
      break;
    case "/shuffle":
      name = VOCAB[state.auth.language]["pages"]["SHUFFLE"];
      break;
    case "/ranking":
      name = "Holistic Ranking";
      break;
    case "/messenger":
      name = VOCAB[state.auth.language]["pages"]["MESSENGER"];
      break;
    case "/settings":
      name = VOCAB[state.auth.language]["pages"]["SETTINGS"];
      break;
    case "/support":
      name = VOCAB[state.auth.language]["pages"]["SUPPORT"];
      break;
    case "/feedback":
      name = VOCAB[state.auth.language]["pages"]["FEEDBACK"];
      break;
    case "/results":
      name = VOCAB[state.auth.language]["pages"]["RESULTS"];
      break;
    case "/events":
      name = VOCAB[state.auth.language]["pages"]["EVENTS"];
      break;
    case "/attendance":
      name = VOCAB[state.auth.language]["pages"]["ATTENDANCE"];
      break;
    case "/exams":
      name = VOCAB[state.auth.language]["pages"]["EXAMS"];
      break;
    case "/leave_requests":
      name = VOCAB[state.auth.language]["pages"]["LEAVES"];
      break;
    case "/approvals":
      name = "Approvals";
      break;
    case "/all_routes":
      name = VOCAB[state.auth.language]["pages"]["ROUTES"];
      break;
    case "/journeys":
      name = VOCAB[state.auth.language]["pages"]["JOURNEYS"];
      break;
    case "/notifications":
      name = VOCAB[state.auth.language]["pages"]["NOTIFICATIONS"];
      break;
    default:
      name = "Dashboard";
  }

  const menuId = "primary-search-account-menu";
  const notificationsMenuId = "primary-notifications-menu";

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <Link style={{ textDecoration: "none", color: "black" }} to={"/settings"}>
        <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      </Link>
      <Link style={{ textDecoration: "none", color: "black" }} to={"/support"}>
        <MenuItem onClick={handleMenuClose}>Support</MenuItem>
      </Link>

      <Link
        style={{ textDecoration: "none", color: "black" }}
        to={"/feedback-form"}
      >
        <MenuItem onClick={handleMenuClose}>Feedback</MenuItem>
      </Link>
      <Link
        style={{ textDecoration: "none", color: "black" }}
        to={"/error-report"}
      >
        <MenuItem onClick={handleMenuClose}>Report Error</MenuItem>
      </Link>
      <Link style={{ textDecoration: "none", color: "black" }} to={"/logout"}>
        <MenuItem onClick={handleMenuClose}>Logout</MenuItem>
      </Link>
    </Menu>
  );

  const renderNotifications = (
    <Menu
      anchorEl={anchorE2}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={notificationsMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isNotificationsOpen}
      onClose={handleNotificationsClose}
    >
      {state.auth.unseenNotifications.map((notification, index) => (
        <MenuItem
          style={{
            width: "500px",
            height: "60px",
            display: notification["seen"] == false ? "flex" : "none",
            justifyContent: "space-between",
          }}
          onClick={() => {
            updateNotificationSeen(notification["id"]);
            handleNotificationsClose();

            navigate(
              "/" + notification["page"] + "?tab=" + notification["tab"],
            );
          }}
          sx={{
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: themeStyle.primaryColorLight,
            },
          }}
        >
          <span>
            <span
              style={{
                marginTop: "-20px",
                fontWeight: "bold",

                color: themeStyle.primaryColor,
              }}
            >
              {notification["title"]}
            </span>
            <div style={{ color: "black", marginTop: "-5px" }}>
              {notification["body"]}
            </div>
          </span>
        </MenuItem>
      ))}
      {state.auth.unseenNotifications.length == 0 ? (
        <MenuItem
          style={{
            width: "500px",
            height: "30px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span>
            <span style={{ color: "grey", textAlign: "left" }}>
              No new notifications.
            </span>
          </span>
          <EmojiEmotionsIcon style={{ color: "#FFD960" }} />
        </MenuItem>
      ) : (
        ""
      )}
      <br />
      <Link
        style={{ textDecoration: "none", color: themeStyle.primaryColor }}
        to="/notifications"
      >
        <MenuItem
          style={{
            width: "500px",
            height: "40px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <div style={{ display: "flex" }}>
            <span
              style={{ color: themeStyle.primaryColor, textAlign: "right" }}
            >
              See all notifications
            </span>
            <ArrowForwardIosIcon
              style={{
                marginTop: "-3px",
                color: themeStyle.primaryColor,
                marginLeft: "15px",
              }}
            />
          </div>
        </MenuItem>
      </Link>

      <MenuItem
        onClick={() => clearAllNotifications()}
        style={{
          width: "500px",
          height: "40px",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <div style={{ display: "flex" }}>
          <span style={{ color: "#ff3333", textAlign: "right" }}>
            Clear all notifications
          </span>
          <DeleteIcon
            style={{
              marginTop: "-3px",
              color: "#ff3333",
              marginLeft: "15px",
            }}
          />
        </div>
      </MenuItem>
    </Menu>
  );

  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      {/* <MenuItem>
        <IconButton size="large" aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={4} color="error">
            <MailIcon />
          </Badge>
        </IconButton>
        <p>Messages</p>
      </MenuItem> */}
      <MenuItem onClick={handleNotificationsMenuOpen}>
        <IconButton
          size="large"
          aria-label="show 17 new notifications"
          color="inherit"
        >
          <Badge
            badgeContent={state.auth.unseenNotifications.length}
            color="error"
          >
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  if (state.auth.alert) {
    setSnack2({
      title: state.auth.alert.title,
      message: state.auth.alert.message,
      type: state.auth.alert.type,
    });
    setShowSnack2(true);
    dispatch({ type: "REMOVE_ALERT" });
  }

  if (!state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      if (!state.auth.isSocketLoading) {
        state.auth.client.onopen = () => {
          console.log("socket");
        };
        state.auth.client.onmessage = (message) => {
          dispatch(getNotifications());
          var client_message = JSON.parse(message.data);
          console.log(client_message);
          var type = client_message["type"];
          if (type == "text" || type == "attachment") {
            if (state.auth.user.is_parent) {
              dispatch(
                loadMessages(
                  (state.auth.user.institution_id,
                  state.auth.user.user_id,
                  state.auth.class_type,
                  state.auth.student.class_id,
                  state.auth.student.division,
                  state.auth.token),
                ),
              );
            } else if (state.auth.user.is_student) {
              dispatch(
                loadMessages(
                  (state.auth.user.institution_id,
                  state.auth.user.user_id,
                  state.auth.class_type,
                  state.auth.user.class_id,
                  state.auth.user.division,
                  state.auth.token),
                ),
              );
            } else {
              dispatch(
                loadMessages(
                  (state.auth.user.institution_id,
                  state.auth.user.user_id,
                  state.auth.class_type,
                  "",
                  "",
                  state.auth.token),
                ),
              );
            }

            dispatch({ type: "TEXT_MESSAGE", payload: client_message });

            if (window.location.pathname != "/messenger") {
              setSnack({
                title: "New Message!",
                message: client_message["message"],
              });
              setShowSnack(true);
              playAudio();
            }
          }

          if (type == "notification") {
            playAudio();
            setSnack({
              title: client_message["title"],
              message: client_message["message"],
            });
            setShowSnack(true);
            playAudio();
          }
          if (type == "refresh") {
            if (window.location.pathname == "/" + client_message["page"]) {
              dispatch({ type: "REFRESH_DATA", payload: "REFRESH_DATA" });
            }
          }
        };
      }

      return (
        <div style={{ zIndex: "99" }}>
          <CssBaseline />
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openFeedback}
            onClose={() => setOpenFeedback(false)}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={openFeedback}>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  backgroundColor: "white",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 400,
                  padding: "20px",
                  borderRadius: "6px",
                }}
              >
                <div style={{ marginTop: "-25px" }}>
                  <div
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <IconButton size="small">
                      <CloseIcon
                        onClick={() => setOpenFeedback(false)}
                        style={{ color: themeStyle.primaryColor }}
                      />
                    </IconButton>
                  </div>
                  <h3>Welcome to {MAIN_TITLE}</h3>
                  <p>
                    {MAIN_TITLE}, being in the beta stage, may contain bugs or
                    errors. We value your feedback to enhance the user
                    experience
                    <br></br>
                    <br></br>
                  </p>
                  <br></br>
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Link
                      style={{ textDecoration: "none", color: "black" }}
                      to={"/feedback_report"}
                    >
                      <Button
                        onClick={() => {
                          setOpenFeedback(false);
                        }}
                        style={{ height: "30px" }}
                        variant="contained"
                      >
                        Give Feedback
                      </Button>
                    </Link>
                    <Button
                      style={{ height: "30px", marginLeft: "10px" }}
                      variant="contained"
                      onClick={() => setOpenFeedback(false)}
                    >
                      No
                    </Button>
                  </div>
                </div>
              </div>
            </Fade>
          </Modal>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openError}
            onClose={() => setOpenError(false)}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={openError}>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  backgroundColor: "white",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 400,
                  padding: "20px",
                  borderRadius: "6px",
                }}
              >
                <div style={{ marginTop: "-25px" }}>
                  <div
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <IconButton size="small">
                      <CloseIcon
                        onClick={() => setOpenError(false)}
                        style={{ color: themeStyle.primaryColor }}
                      />
                    </IconButton>
                  </div>
                  <h3>Welcome to {MAIN_TITLE}</h3>
                  <p>
                    {MAIN_TITLE}, being in the beta stage, may contain bugs or
                    errors. We value your feedback to enhance the user
                    experience
                    <br></br>
                    Please report any errors that you might have experienced.
                    <br></br>
                    <br></br>
                  </p>
                  <br></br>
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Link
                      style={{ textDecoration: "none", color: "black" }}
                      to={"/error_report"}
                    >
                      <Button
                        onClick={() => {
                          setOpenError(false);
                        }}
                        style={{ height: "30px" }}
                        variant="contained"
                      >
                        Report Errors
                      </Button>
                    </Link>
                    <Button
                      style={{ height: "30px", marginLeft: "10px" }}
                      variant="contained"
                      onClick={() => setOpenError(false)}
                    >
                      No
                    </Button>
                  </div>
                </div>
              </div>
            </Fade>
          </Modal>
          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            autoHideDuration={6000}
            open={showSnack}
            onClose={() => setShowSnack(false)}
          >
            <Card style={{ minWidth: "350px", padding: "10px" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex" }}>
                  <NotificationsIcon
                    style={{ color: themeStyle.primaryColor, fontSize: "44px" }}
                  />
                  <div style={{ marginLeft: "10px" }}>
                    <b style={{ fontSize: "15px" }}>{snack["title"]}</b>
                    <br></br>
                    <span>{snack["message"]}</span>
                  </div>
                </div>
                <IconButton size="small" onClick={() => setShowSnack(false)}>
                  <CloseIcon style={{ color: themeStyle.primaryColor }} />
                </IconButton>
              </div>
            </Card>
          </Snackbar>
          <Snackbar
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            autoHideDuration={6000}
            open={showSnack2}
            onClose={() => setShowSnack2(false)}
          >
            <Card style={{ minWidth: "350px", padding: "10px" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex" }}>
                  {snack2["type"] == "SUCCESS" ? (
                    <CheckCircleIcon
                      style={{ color: "#2ca25f", fontSize: "44px" }}
                    />
                  ) : snack2["type"] == "MESSAGE" ? (
                    <ErrorIcon
                      style={{
                        color: themeStyle.primaryColor,
                        fontSize: "44px",
                      }}
                    />
                  ) : (
                    <ErrorIcon style={{ color: "#ff3333", fontSize: "44px" }} />
                  )}
                  <div style={{ marginLeft: "10px" }}>
                    <b style={{ fontSize: "15px" }}>{snack2["title"]}</b>
                    <br></br>
                    <span>{snack2["message"]}</span>
                  </div>
                </div>
                <IconButton size="small" onClick={() => setShowSnack2(false)}>
                  <CloseIcon style={{ color: themeStyle.primaryColor }} />
                </IconButton>
              </div>
            </Card>
          </Snackbar>
          <AppBar elevation={0} position="fixed" open={open}>
            <Toolbar>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                sx={{
                  marginRight: 5,
                  marginLeft: "-8px",
                  ...(open && { display: "none" }),
                }}
              >
                <MenuIcon />
              </IconButton>
              {open ? (
                <Fragment></Fragment>
              ) : (
                <Divider
                  orientation="vertical"
                  style={{
                    minHeight: "inherit",
                    color: "#ff3333",
                    width: "1px",
                    marginLeft: "-24px",
                  }}
                />
              )}
              <span
                style={{
                  marginLeft: "16px",
                  fontSize: "25px",
                  marginTop: "3px",
                  fontWeight: "bold",
                  color: themeStyle.secondaryColor,
                }}
              >
                {name}
              </span>{" "}
              <Box sx={{ flexGrow: 1 }} />
              <div style={{ margin: "10px 17px 10px 10px", width: "50%" }}>
                {props.tabs}
              </div>
              <Box
                sx={{ display: { xs: "none", md: "flex" } }}
                style={{ alignItems: "center" }}
              >
                {/* <IconButton
                  size="large"
                  aria-label="show 4 new mails"
                  color="inherit"
                >
                  <Badge badgeContent={4} color="error">
                    <MailIcon />
                  </Badge>
                </IconButton> */}
                <IconButton
                  size="large"
                  aria-label="show 17 new notifications"
                  color="inherit"
                  aria-controls={notificationsMenuId}
                  aria-haspopup="true"
                  onClick={handleNotificationsMenuOpen}
                  style={{ marginLeft: "15px" }}
                >
                  <Badge
                    badgeContent={state.auth.unseenNotifications.length}
                    color="error"
                  >
                    <NotificationsIcon />
                  </Badge>
                </IconButton>
                {/*state.auth.user.is_parent ? (
                  <div
                    style={{
                      marginLeft: "15px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      borderRadius: "25px",
                      height: "45px",
                      border: "2px solid " + themeStyle.primaryColor,
                    }}
                  >
                    <Tooltip
                      style={{ marginLeft: "-12px" }}
                      arrow
                      title={
                        state.auth.student != null
                          ? state.auth.student.full_name
                          : ""
                      }
                      placement="right"
                    >
                      <IconButton
                        size="large"
                        edge="end"
                        aria-label="account of current student"
                        aria-haspopup="true"
                        color="inherit"
                        onClick={() => {
                          dispatch({ type: "CLEAR_STUDENT" });
                          navigate("/student_profile");
                        }}
                      >
                        <Avatar
                          alt={
                            state.auth.student != null
                              ? state.auth.student.full_name
                              : ""
                          }
                          src={
                            state.auth.student != null
                              ? API_URL +
                                "/media/" +
                                state.auth.student.user_image
                              : ""
                          }
                        />{" "}
                      </IconButton>
                    </Tooltip>
                    <div style={{ marginLeft: "10px", marginRight: "15px" }}>
                      {state.auth.student.full_name}
                    </div>
                  </div>
                ) : (
                  ""
                )*/}
                <Tooltip
                  arrow
                  title={state.auth.user.full_name}
                  placement="right"
                >
                  <IconButton
                    size="large"
                    edge="end"
                    aria-label="account of current user"
                    aria-controls={menuId}
                    aria-haspopup="true"
                    onClick={handleProfileMenuOpen}
                    color="inherit"
                  >
                    <Avatar
                      alt={state.auth.user.full_name}
                      src={API_URL + "/media/" + state.auth.user.user_image}
                    />{" "}
                  </IconButton>
                </Tooltip>
              </Box>
              <Box sx={{ display: { xs: "flex", md: "none" } }}>
                <Tooltip
                  arrow
                  title={state.auth.user.full_name}
                  placement="right"
                >
                  <IconButton
                    size="large"
                    aria-label="show more"
                    aria-controls={mobileMenuId}
                    aria-haspopup="true"
                    onClick={handleMobileMenuOpen}
                    color="inherit"
                  >
                    <Avatar
                      alt={state.auth.user.full_name}
                      src={API_URL + "/media/" + state.auth.user.user_image}
                    />{" "}
                  </IconButton>
                </Tooltip>
              </Box>
            </Toolbar>
          </AppBar>
          {renderMobileMenu}
          {renderMenu}
          {renderNotifications}
          <Drawer
            PaperProps={{
              sx: {
                backgroundColor: themeStyle.primaryColorLight,
              },
            }}
            variant="permanent"
            open={open}
          >
            <DrawerHeader>
              <a style={{ textDecoration: "none" }} href={DOMAIN_URL}>
                <img
                  style={{
                    maxHeight: "30px",
                    marginTop: "10px",
                  }}
                  src={require("../img/" + SIDEBAR)}
                />
              </a>
              <IconButton
                style={{
                  color: themeStyle.secondaryColor,
                  fontSize: "20px",
                  fontWeight: "800",
                  marginLeft: "-1px",
                }}
                onClick={handleDrawerClose}
              >
                {theme.direction === "rtl" ? (
                  <ChevronRightIcon />
                ) : (
                  <ChevronLeftIcon />
                )}
              </IconButton>
            </DrawerHeader>
            <List
              component="nav"
              aria-label="main mailbox folders"
              style={{ marginTop: "-8px" }}
            >
              <Link to="/dashboard">
                <Tooltip arrow title="Dashboard" placement="right">
                  <ListItem
                    button
                    key="dashboard"
                    style={
                      window.location.pathname === "/" ||
                      window.location.pathname === "/dashboard"
                        ? open
                          ? {
                              backgroundColor: themeStyle.primaryColor,
                              borderRadius: "50px",
                              margin: "7.5px",
                              width: "93%",
                            }
                          : {
                              backgroundColor: themeStyle.primaryColor,
                              borderRadius: "50px",
                              margin: "7.5px",
                              width: "75%",
                            }
                        : {}
                    }
                  >
                    <ListItemIcon>
                      <DashboardIcon
                        style={
                          window.location.pathname === "/" ||
                          window.location.pathname === "/dashboard"
                            ? {
                                marginLeft: open ? "8px" : "-2px",
                                marginRight: "30px",
                                color: "white",
                                fontSize: "25px",
                              }
                            : {
                                marginLeft: "8px",
                                marginRight: "30px",
                                color: "#888",
                              }
                        }
                      />
                    </ListItemIcon>
                    <ListItemText
                      primaryTypographyProps={{
                        fontSize: "18px",
                        fontFamily: "Campton Book",
                        fontWeight:
                          window.location.pathname === "/" ||
                          window.location.pathname === "/dashboard"
                            ? "bold"
                            : "normal",
                        color:
                          window.location.pathname === "/" ||
                          window.location.pathname === "/dashboard"
                            ? "white"
                            : "#888",
                      }}
                      primary={VOCAB[state.auth.language]["pages"]["DASHBOARD"]}
                    />
                  </ListItem>
                </Tooltip>
              </Link>
              {state.auth.user.is_principal ||
              state.auth.user.is_teacher ||
              state.auth.user.is_student ||
              state.auth.user.is_parent ? (
                <Link to="/exams">
                  <Tooltip arrow title="Exams" placement="right">
                    <ListItem
                      button
                      key="exams"
                      style={
                        window.location.pathname === "/exams"
                          ? open
                            ? {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "93%",
                              }
                            : {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "75%",
                              }
                          : {}
                      }
                    >
                      <ListItemIcon>
                        <WorkspacesIcon
                          style={
                            window.location.pathname === "/exams"
                              ? {
                                  marginLeft: open ? "8px" : "-2px",
                                  marginRight: "30px",
                                  color: "white",
                                  fontSize: "25px",
                                }
                              : {
                                  marginLeft: "8px",
                                  marginRight: "30px",
                                  color: "#888",
                                }
                          }
                        />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: "18px",
                          fontFamily: "Campton Book",
                          fontWeight:
                            window.location.pathname === "/exams"
                              ? "bold"
                              : "normal",
                          color:
                            window.location.pathname === "/exams"
                              ? "white"
                              : "#888",
                        }}
                        primary={VOCAB[state.auth.language]["pages"]["EXAMS"]}
                      />
                    </ListItem>
                  </Tooltip>
                </Link>
              ) : (
                ""
              )}
              {state.auth.user.is_inventory || state.auth.user.is_principal ? (
                <Link to="/inventory">
                  <Tooltip arrow title="Inventory" placement="right">
                    <ListItem
                      button
                      key="inventory"
                      style={
                        window.location.pathname === "/inventory"
                          ? open
                            ? {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "93%",
                              }
                            : {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "75%",
                              }
                          : {}
                      }
                    >
                      <ListItemIcon>
                        <InventoryIcon
                          style={
                            window.location.pathname === "/inventory"
                              ? {
                                  marginLeft: open ? "8px" : "-2px",
                                  marginRight: "30px",
                                  color: "white",
                                  fontSize: "25px",
                                }
                              : {
                                  marginLeft: "8px",
                                  marginRight: "30px",
                                  color: "#888",
                                }
                          }
                        />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: "18px",
                          fontFamily: "Campton Book",
                          fontWeight:
                            window.location.pathname === "/inventory"
                              ? "bold"
                              : "normal",
                          color:
                            window.location.pathname === "/inventory"
                              ? "white"
                              : "#888",
                        }}
                        primary={
                          VOCAB[state.auth.language]["pages"]["INVENTORY"]
                        }
                      />
                    </ListItem>
                  </Tooltip>
                </Link>
              ) : (
                ""
              )}
              {state.auth.user.is_transport ? (
                <Link to="/all_routes">
                  <Tooltip arrow title="Routes" placement="right">
                    <ListItem
                      button
                      key="all_routes"
                      style={
                        window.location.pathname === "/all_routes"
                          ? open
                            ? {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "93%",
                              }
                            : {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "75%",
                              }
                          : {}
                      }
                    >
                      <ListItemIcon>
                        <MergeIcon
                          style={
                            window.location.pathname === "/all_routes"
                              ? {
                                  marginLeft: open ? "8px" : "-2px",
                                  marginRight: "30px",
                                  color: "white",
                                  fontSize: "25px",
                                }
                              : {
                                  marginLeft: "8px",
                                  marginRight: "30px",
                                  color: "#888",
                                }
                          }
                        />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: "18px",
                          fontFamily: "Campton Book",
                          fontWeight:
                            window.location.pathname === "/all_routes"
                              ? "bold"
                              : "normal",
                          color:
                            window.location.pathname === "/all_routes"
                              ? "white"
                              : "#888",
                        }}
                        primary={VOCAB[state.auth.language]["pages"]["ROUTES"]}
                      />
                    </ListItem>
                  </Tooltip>
                </Link>
              ) : (
                ""
              )}
              {state.auth.user.is_transport ? (
                <Link to="/journeys">
                  <Tooltip arrow title="Journeys" placement="right">
                    <ListItem
                      button
                      key="journeys"
                      style={
                        window.location.pathname === "/journeys"
                          ? open
                            ? {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "93%",
                              }
                            : {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "75%",
                              }
                          : {}
                      }
                    >
                      <ListItemIcon>
                        <DepartureBoardIcon
                          style={
                            window.location.pathname === "/journeys"
                              ? {
                                  marginLeft: open ? "8px" : "-2px",
                                  marginRight: "30px",
                                  color: "white",
                                  fontSize: "25px",
                                }
                              : {
                                  marginLeft: "8px",
                                  marginRight: "30px",
                                  color: "#888",
                                }
                          }
                        />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: "18px",
                          fontFamily: "Campton Book",
                          fontWeight:
                            window.location.pathname === "/journeys"
                              ? "bold"
                              : "normal",
                          color:
                            window.location.pathname === "/journeys"
                              ? "white"
                              : "#888",
                        }}
                        primary={
                          VOCAB[state.auth.language]["pages"]["JOURNEYS"]
                        }
                      />
                    </ListItem>
                  </Tooltip>
                </Link>
              ) : (
                ""
              )}
              {state.auth.user.is_transport ? (
                <Link to="/drivers">
                  <Tooltip arrow title="Drivers" placement="right">
                    <ListItem
                      button
                      key="drivers"
                      style={
                        window.location.pathname === "/drivers"
                          ? open
                            ? {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "93%",
                              }
                            : {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "75%",
                              }
                          : {}
                      }
                    >
                      <ListItemIcon>
                        <Groups
                          style={
                            window.location.pathname === "/drivers"
                              ? {
                                  marginLeft: open ? "8px" : "-2px",
                                  marginRight: "30px",
                                  color: "white",
                                  fontSize: "25px",
                                }
                              : {
                                  marginLeft: "8px",
                                  marginRight: "30px",
                                  color: "#888",
                                }
                          }
                        />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: "18px",
                          fontFamily: "Campton Book",
                          fontWeight:
                            window.location.pathname === "/drivers"
                              ? "bold"
                              : "normal",
                          color:
                            window.location.pathname === "/drivers"
                              ? "white"
                              : "#888",
                        }}
                        primary={VOCAB[state.auth.language]["pages"]["DRIVERS"]}
                      />
                    </ListItem>
                  </Tooltip>
                </Link>
              ) : (
                ""
              )}

              {state.auth.user.is_onboarding ||
              state.auth.user.is_billing ||
              state.auth.user.is_principal ? (
                <Link to="/registrations">
                  <Tooltip arrow title="Registrations" placement="right">
                    <ListItem
                      button
                      key="registrations"
                      style={
                        window.location.pathname === "/registrations"
                          ? open
                            ? {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "93%",
                              }
                            : {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "75%",
                              }
                          : {}
                      }
                    >
                      <ListItemIcon>
                        <HowToRegIcon
                          style={
                            window.location.pathname === "/registrations"
                              ? {
                                  marginLeft: open ? "8px" : "-2px",
                                  marginRight: "30px",
                                  color: "white",
                                  fontSize: "25px",
                                }
                              : {
                                  marginLeft: "8px",
                                  marginRight: "30px",
                                  color: "#888",
                                }
                          }
                        />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: "18px",
                          fontFamily: "Campton Book",
                          fontWeight:
                            window.location.pathname === "/registrations"
                              ? "bold"
                              : "normal",
                          color:
                            window.location.pathname === "/registrations"
                              ? "white"
                              : "#888",
                        }}
                        primary={
                          VOCAB[state.auth.language]["pages"]["REGISTRATIONS"]
                        }
                      />
                    </ListItem>
                  </Tooltip>
                </Link>
              ) : (
                ""
              )}

              {state.auth.user.is_principal ? (
                <Link to="/timetable">
                  <Tooltip arrow title="Time Table" placement="right">
                    <ListItem
                      button
                      key="timetable"
                      style={
                        window.location.pathname === "/timetable"
                          ? open
                            ? {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "93%",
                              }
                            : {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "75%",
                              }
                          : {}
                      }
                    >
                      <ListItemIcon>
                        <ViewTimelineIcon
                          style={
                            window.location.pathname === "/timetable"
                              ? {
                                  marginLeft: open ? "8px" : "-2px",
                                  marginRight: "30px",
                                  color: "white",
                                  fontSize: "25px",
                                }
                              : {
                                  marginLeft: "8px",
                                  marginRight: "30px",
                                  color: "#888",
                                }
                          }
                        />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: "18px",
                          fontFamily: "Campton Book",
                          fontWeight:
                            window.location.pathname === "/timetable"
                              ? "bold"
                              : "normal",
                          color:
                            window.location.pathname === "/timetable"
                              ? "white"
                              : "#888",
                        }}
                        primary={
                          VOCAB[state.auth.language]["pages"]["TIMETABLE"]
                        }
                      />
                    </ListItem>
                  </Tooltip>
                </Link>
              ) : (
                ""
              )}

              {state.auth.user.is_onboarding ||
              state.auth.user.is_principal ||
              state.auth.user.is_teacher ||
              state.auth.user.is_transport ? (
                <Link to="/students">
                  <Tooltip arrow title="Students" placement="right">
                    <ListItem
                      button
                      key="students"
                      style={
                        window.location.pathname === "/students"
                          ? open
                            ? {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "93%",
                              }
                            : {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "75%",
                              }
                          : {}
                      }
                    >
                      <ListItemIcon>
                        <Person
                          style={
                            window.location.pathname === "/students"
                              ? {
                                  marginLeft: open ? "8px" : "-2px",
                                  marginRight: "30px",
                                  color: "white",
                                  fontSize: "25px",
                                }
                              : {
                                  marginLeft: "8px",
                                  marginRight: "30px",
                                  color: "#888",
                                }
                          }
                        />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: "18px",
                          fontFamily: "Campton Book",
                          fontWeight:
                            window.location.pathname === "/students"
                              ? "bold"
                              : "normal",
                          color:
                            window.location.pathname === "/students"
                              ? "white"
                              : "#888",
                        }}
                        primary={
                          VOCAB[state.auth.language]["pages"]["STUDENTS"]
                        }
                      />
                    </ListItem>
                  </Tooltip>
                </Link>
              ) : (
                ""
              )}
              {state.auth.user.is_billing ? (
                <Link to="/fee-collection">
                  <Tooltip arrow title="Fee Collection" placement="right">
                    <ListItem
                      button
                      key="fee-collection"
                      style={
                        window.location.pathname === "/fee-collection"
                          ? open
                            ? {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "93%",
                              }
                            : {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "75%",
                              }
                          : {}
                      }
                    >
                      <ListItemIcon>
                        <SchoolIcon
                          style={
                            window.location.pathname === "/fee-collection"
                              ? {
                                  marginLeft: open ? "8px" : "-2px",
                                  marginRight: "30px",
                                  color: "white",
                                  fontSize: "25px",
                                }
                              : {
                                  marginLeft: "8px",
                                  marginRight: "30px",
                                  color: "#888",
                                }
                          }
                        />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: "18px",
                          fontFamily: "Campton Book",
                          fontWeight:
                            window.location.pathname === "/fee-collection"
                              ? "bold"
                              : "normal",
                          color:
                            window.location.pathname === "/fee-collection"
                              ? "white"
                              : "#888",
                        }}
                        primary={
                          VOCAB[state.auth.language]["pages"]["FEE_COLLECTION"]
                        }
                      />
                    </ListItem>
                  </Tooltip>
                </Link>
              ) : (
                ""
              )}
              {state.auth.user.is_billing ? (
                <Link to="/add-fees">
                  <Tooltip arrow title="Add Fees" placement="right">
                    <ListItem
                      button
                      key="add-fees"
                      style={
                        window.location.pathname === "/add-fees"
                          ? open
                            ? {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "93%",
                              }
                            : {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "75%",
                              }
                          : {}
                      }
                    >
                      <ListItemIcon>
                        <AddBoxIcon
                          style={
                            window.location.pathname === "/add-fees"
                              ? {
                                  marginLeft: open ? "8px" : "-2px",
                                  marginRight: "30px",
                                  color: "white",
                                  fontSize: "25px",
                                }
                              : {
                                  marginLeft: "8px",
                                  marginRight: "30px",
                                  color: "#888",
                                }
                          }
                        />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: "18px",
                          fontFamily: "Campton Book",
                          fontWeight:
                            window.location.pathname === "/add-fees"
                              ? "bold"
                              : "normal",
                          color:
                            window.location.pathname === "/add-fees"
                              ? "white"
                              : "#888",
                        }}
                        primary={
                          VOCAB[state.auth.language]["pages"]["ADD_FEES"]
                        }
                      />
                    </ListItem>
                  </Tooltip>
                </Link>
              ) : (
                ""
              )}
              {state.auth.user.is_billing ? (
                <Link to="/fee-structure">
                  <Tooltip arrow title="Add Fees" placement="right">
                    <ListItem
                      button
                      key="add-fees"
                      style={
                        window.location.pathname === "/fee-structure"
                          ? open
                            ? {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "93%",
                              }
                            : {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "75%",
                              }
                          : {}
                      }
                    >
                      <ListItemIcon>
                        <AddBoxIcon
                          style={
                            window.location.pathname === "/fee-structure"
                              ? {
                                  marginLeft: open ? "8px" : "-2px",
                                  marginRight: "30px",
                                  color: "white",
                                  fontSize: "25px",
                                }
                              : {
                                  marginLeft: "8px",
                                  marginRight: "30px",
                                  color: "#888",
                                }
                          }
                        />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: "18px",
                          fontFamily: "Campton Book",
                          fontWeight:
                            window.location.pathname === "/fee-structure"
                              ? "bold"
                              : "normal",
                          color:
                            window.location.pathname === "/fee-structure"
                              ? "white"
                              : "#888",
                        }}
                        primary={
                          VOCAB[state.auth.language]["pages"]["ADD_FEES"]
                        }
                      />
                    </ListItem>
                  </Tooltip>
                </Link>
              ) : (
                ""
              )}
              {state.auth.user.is_onboarding || state.auth.user.is_principal ? (
                <Link to="/teachers">
                  <Tooltip arrow title="Teachers" placement="right">
                    <ListItem
                      button
                      key="teachers"
                      style={
                        window.location.pathname === "/teachers"
                          ? open
                            ? {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "93%",
                              }
                            : {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "75%",
                              }
                          : {}
                      }
                    >
                      <ListItemIcon>
                        <SupervisorAccount
                          style={
                            window.location.pathname === "/teachers"
                              ? {
                                  marginLeft: open ? "8px" : "-2px",
                                  marginRight: "30px",
                                  color: "white",
                                  fontSize: "25px",
                                }
                              : {
                                  marginLeft: "8px",
                                  marginRight: "30px",
                                  color: "#888",
                                }
                          }
                        />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: "18px",
                          fontFamily: "Campton Book",
                          fontWeight:
                            window.location.pathname === "/teachers"
                              ? "bold"
                              : "normal",
                          color:
                            window.location.pathname === "/teachers"
                              ? "white"
                              : "#888",
                        }}
                        primary={
                          VOCAB[state.auth.language]["pages"]["TEACHERS"]
                        }
                      />
                    </ListItem>
                  </Tooltip>
                </Link>
              ) : (
                ""
              )}
              {state.auth.user.is_onboarding || state.auth.user.is_principal ? (
                <Link to="/staff">
                  <Tooltip arrow title="Staff" placement="right">
                    <ListItem
                      button
                      key="staff"
                      style={
                        window.location.pathname === "/staff"
                          ? open
                            ? {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "93%",
                              }
                            : {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "75%",
                              }
                          : {}
                      }
                    >
                      <ListItemIcon>
                        <Groups
                          style={
                            window.location.pathname === "/staff"
                              ? {
                                  marginLeft: open ? "8px" : "-2px",
                                  marginRight: "30px",
                                  color: "white",
                                  fontSize: "25px",
                                }
                              : {
                                  marginLeft: "8px",
                                  marginRight: "30px",
                                  color: "#888",
                                }
                          }
                        />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: "18px",
                          fontFamily: "Campton Book",
                          fontWeight:
                            window.location.pathname === "/staff"
                              ? "bold"
                              : "normal",
                          color:
                            window.location.pathname === "/staff"
                              ? "white"
                              : "#888",
                        }}
                        primary={VOCAB[state.auth.language]["pages"]["STAFF"]}
                      />
                    </ListItem>
                  </Tooltip>
                </Link>
              ) : (
                ""
              )}

              {state.auth.user.is_student ||
              state.auth.user.is_teacher ||
              state.auth.user.is_onboarding ||
              state.auth.user.is_parent ? (
                <Link to="/classes">
                  <Tooltip arrow title="Classes" placement="right">
                    <ListItem
                      button
                      key="classes"
                      style={
                        window.location.pathname === "/classes"
                          ? open
                            ? {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "93%",
                              }
                            : {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "75%",
                              }
                          : {}
                      }
                    >
                      <ListItemIcon>
                        <SchoolIcon
                          style={
                            window.location.pathname === "/classes"
                              ? {
                                  marginLeft: open ? "8px" : "-2px",
                                  marginRight: "30px",
                                  color: "white",
                                  fontSize: "25px",
                                }
                              : {
                                  marginLeft: "8px",
                                  marginRight: "30px",
                                  color: "#888",
                                }
                          }
                        />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: "18px",
                          fontFamily: "Campton Book",
                          fontWeight:
                            window.location.pathname === "/classes"
                              ? "bold"
                              : "normal",
                          color:
                            window.location.pathname === "/classes"
                              ? "white"
                              : "#888",
                        }}
                        primary={VOCAB[state.auth.language]["pages"]["CLASSES"]}
                      />
                    </ListItem>
                  </Tooltip>
                </Link>
              ) : (
                ""
              )}
              {state.auth.user.is_onboarding ? (
                <Link to="/shuffle">
                  <Tooltip arrow title="Shuffle" placement="right">
                    <ListItem
                      button
                      key="shuffle"
                      style={
                        window.location.pathname === "/shuffle"
                          ? open
                            ? {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "93%",
                              }
                            : {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "75%",
                              }
                          : {}
                      }
                    >
                      <ListItemIcon>
                        <Shuffle
                          style={
                            window.location.pathname === "/shuffle"
                              ? {
                                  marginLeft: open ? "8px" : "-2px",
                                  marginRight: "30px",
                                  color: "white",
                                  fontSize: "25px",
                                }
                              : {
                                  marginLeft: "8px",
                                  marginRight: "30px",
                                  color: "#888",
                                }
                          }
                        />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: "18px",
                          fontFamily: "Campton Book",
                          fontWeight:
                            window.location.pathname === "/shuffle"
                              ? "bold"
                              : "normal",
                          color:
                            window.location.pathname === "/shuffle"
                              ? "white"
                              : "#888",
                        }}
                        primary={VOCAB[state.auth.language]["pages"]["SHUFFLE"]}
                      />
                    </ListItem>
                  </Tooltip>
                </Link>
              ) : (
                ""
              )}
              {state.auth.user.is_principal ||
              state.auth.user.is_teacher ||
              state.auth.user.is_student ||
              state.auth.user.is_parent ? (
                <Link to="/results">
                  <Tooltip arrow title="Results" placement="right">
                    <ListItem
                      button
                      key="results"
                      style={
                        window.location.pathname === "/results"
                          ? open
                            ? {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "93%",
                              }
                            : {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "75%",
                              }
                          : {}
                      }
                    >
                      <ListItemIcon>
                        <ListAltIcon
                          style={
                            window.location.pathname === "/results"
                              ? {
                                  marginLeft: open ? "8px" : "-2px",
                                  marginRight: "30px",
                                  color: "white",
                                  fontSize: "25px",
                                }
                              : {
                                  marginLeft: "8px",
                                  marginRight: "30px",
                                  color: "#888",
                                }
                          }
                        />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: "18px",
                          fontFamily: "Campton Book",
                          fontWeight:
                            window.location.pathname === "/results"
                              ? "bold"
                              : "normal",
                          color:
                            window.location.pathname === "/results"
                              ? "white"
                              : "#888",
                        }}
                        primary={VOCAB[state.auth.language]["pages"]["RESULTS"]}
                      />
                    </ListItem>
                  </Tooltip>
                </Link>
              ) : (
                ""
              )}
              {state.auth.user.is_parent ? (
                <Link to="/fees-parent">
                  <Tooltip arrow title="Fees Parent" placement="right">
                    <ListItem
                      button
                      key="fees-parent"
                      style={
                        window.location.pathname === "/fees-parent"
                          ? open
                            ? {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "93%",
                              }
                            : {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "75%",
                              }
                          : {}
                      }
                    >
                      <ListItemIcon>
                        <AccountBalanceWalletIcon
                          style={
                            window.location.pathname === "/fees-parent"
                              ? {
                                  marginLeft: open ? "8px" : "-2px",
                                  marginRight: "30px",
                                  color: "white",
                                  fontSize: "25px",
                                }
                              : {
                                  marginLeft: "8px",
                                  marginRight: "30px",
                                  color: "#888",
                                }
                          }
                        />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: "18px",
                          fontFamily: "Campton Book",
                          fontWeight:
                            window.location.pathname === "/fees-parent"
                              ? "bold"
                              : "normal",
                          color:
                            window.location.pathname === "/fees-parent"
                              ? "white"
                              : "#888",
                        }}
                        primary={
                          VOCAB[state.auth.language]["pages"]["FEES_PARENT"]
                        }
                      />
                    </ListItem>
                  </Tooltip>
                </Link>
              ) : (
                ""
              )}

              {state.auth.user.is_teacher ||
              state.auth.user.is_student ||
              state.auth.user.is_principal ||
              state.auth.user.is_attendance ||
              state.auth.user.is_attendance2 ||
              state.auth.user.is_parent ? (
                <Link to="/attendance">
                  <Tooltip arrow title="Attendance" placement="right">
                    <ListItem
                      button
                      key="attendance"
                      style={
                        window.location.pathname === "/attendance"
                          ? open
                            ? {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "93%",
                              }
                            : {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "75%",
                              }
                          : {}
                      }
                    >
                      <ListItemIcon>
                        <AssignmentTurnedInIcon
                          style={
                            window.location.pathname === "/attendance"
                              ? {
                                  marginLeft: open ? "8px" : "-2px",
                                  marginRight: "30px",
                                  color: "white",
                                  fontSize: "25px",
                                }
                              : {
                                  marginLeft: "8px",
                                  marginRight: "30px",
                                  color: "#888",
                                }
                          }
                        />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: "18px",
                          fontFamily: "Campton Book",
                          fontWeight:
                            window.location.pathname === "/attendance"
                              ? "bold"
                              : "normal",
                          color:
                            window.location.pathname === "/attendance"
                              ? "white"
                              : "#888",
                        }}
                        primary={
                          VOCAB[state.auth.language]["pages"]["ATTENDANCE"]
                        }
                      />
                    </ListItem>
                  </Tooltip>
                </Link>
              ) : (
                ""
              )}
              {state.auth.user.is_parent ? (
                <Link to="/student_profile">
                  <Tooltip arrow title="Student Profile" placement="right">
                    <ListItem
                      button
                      key="student_profile"
                      style={
                        window.location.pathname === "/student_profile"
                          ? open
                            ? {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "93%",
                              }
                            : {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "75%",
                              }
                          : {}
                      }
                    >
                      <ListItemIcon>
                        <HealthAndSafetyIcon
                          style={
                            window.location.pathname === "/student_profile"
                              ? {
                                  marginLeft: open ? "8px" : "-2px",
                                  marginRight: "30px",
                                  color: "white",
                                  fontSize: "25px",
                                }
                              : {
                                  marginLeft: "8px",
                                  marginRight: "30px",
                                  color: "#888",
                                }
                          }
                        />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: "18px",
                          fontFamily: "Campton Book",
                          fontWeight:
                            window.location.pathname === "/student_profile"
                              ? "bold"
                              : "normal",
                          color:
                            window.location.pathname === "/student_profile"
                              ? "white"
                              : "#888",
                        }}
                        primary={VOCAB[state.auth.language]["pages"]["LEAVES"]}
                      />
                    </ListItem>
                  </Tooltip>
                </Link>
              ) : (
                ""
              )}
              {state.auth.user.is_principal ||
              state.auth.user.is_teacher ||
              state.auth.user.is_student ||
              state.auth.user.is_parent ? (
                <Link to="/leave_requests">
                  <Tooltip arrow title="Leave Requests" placement="right">
                    <ListItem
                      button
                      key="leave_requests"
                      style={
                        window.location.pathname === "/leave_requests"
                          ? open
                            ? {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "93%",
                              }
                            : {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "75%",
                              }
                          : {}
                      }
                    >
                      <ListItemIcon>
                        <HealthAndSafetyIcon
                          style={
                            window.location.pathname === "/leave_requests"
                              ? {
                                  marginLeft: open ? "8px" : "-2px",
                                  marginRight: "30px",
                                  color: "white",
                                  fontSize: "25px",
                                }
                              : {
                                  marginLeft: "8px",
                                  marginRight: "30px",
                                  color: "#888",
                                }
                          }
                        />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: "18px",
                          fontFamily: "Campton Book",
                          fontWeight:
                            window.location.pathname === "/leave_requests"
                              ? "bold"
                              : "normal",
                          color:
                            window.location.pathname === "/leave_requests"
                              ? "white"
                              : "#888",
                        }}
                        primary={VOCAB[state.auth.language]["pages"]["LEAVES"]}
                      />
                    </ListItem>
                  </Tooltip>
                </Link>
              ) : (
                ""
              )}

              <Link to="/events">
                <Tooltip arrow title="Events" placement="right">
                  <ListItem
                    button
                    key="events"
                    style={
                      window.location.pathname === "/events"
                        ? open
                          ? {
                              backgroundColor: themeStyle.primaryColor,
                              borderRadius: "50px",
                              margin: "7.5px",
                              width: "93%",
                            }
                          : {
                              backgroundColor: themeStyle.primaryColor,
                              borderRadius: "50px",
                              margin: "7.5px",
                              width: "75%",
                            }
                        : {}
                    }
                  >
                    <ListItemIcon>
                      <DateRangeIcon
                        style={
                          window.location.pathname === "/events"
                            ? {
                                marginLeft: open ? "8px" : "-2px",
                                marginRight: "30px",
                                color: "white",
                                fontSize: "25px",
                              }
                            : {
                                marginLeft: "8px",
                                marginRight: "30px",
                                color: "#888",
                              }
                        }
                      />
                    </ListItemIcon>
                    <ListItemText
                      primaryTypographyProps={{
                        fontSize: "18px",
                        fontFamily: "Campton Book",
                        fontWeight:
                          window.location.pathname === "/events"
                            ? "bold"
                            : "normal",
                        color:
                          window.location.pathname === "/events"
                            ? "white"
                            : "#888",
                      }}
                      primary={VOCAB[state.auth.language]["pages"]["EVENTS"]}
                    />
                  </ListItem>
                </Tooltip>
              </Link>

              {/* {state.auth.user.is_principal ||
              state.auth.user.is_teacher ||
              state.auth.user.is_student ? (
                <Link to="/ranking">
                  <Tooltip arrow title="Holistic Ranking" placement="right">
                    <ListItem
                      button
                      key="ranking"
                      style={
                        window.location.pathname === "/ranking"
                          ? open
                            ? {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "93%",
                              }
                            : {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "75%",
                              }
                          : {}
                      }
                    >
                      <ListItemIcon>
                        <TrendingUpIcon
                          style={
                            window.location.pathname === "/ranking"
                              ? {
                                  marginLeft: open ? "8px" : "-2px",
                                  marginRight: "30px",
                                  color: "white",
                                  fontSize: "25px",
                                }
                              : {
                                  marginLeft: "8px",
                                  marginRight: "30px",
                                  color: "#888",
                                }
                          }
                        />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: "18px",
                          fontFamily: "Campton Book",
                          fontWeight:
                            window.location.pathname === "/ranking"
                              ? "bold"
                              : "normal",
                          color:
                            window.location.pathname === "/ranking"
                              ? "white"
                              : "#888",
                        }}
                        primary={VOCAB[state.auth.language]["pages"]["RANKING"]}
                      />
                    </ListItem>
                  </Tooltip>
                </Link>
              ) : (
                ""
              )} */}
              {state.auth.user.is_principal ||
              state.auth.user.is_teacher ||
              state.auth.user.is_student ? (
                <Link to="/feedback">
                  <Tooltip arrow title="Feedback" placement="right">
                    <ListItem
                      button
                      key="feedback"
                      style={
                        window.location.pathname === "/feedback"
                          ? open
                            ? {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "93%",
                              }
                            : {
                                backgroundColor: themeStyle.primaryColor,
                                borderRadius: "50px",
                                margin: "7.5px",
                                width: "75%",
                              }
                          : {}
                      }
                    >
                      <ListItemIcon>
                        <ThumbsUpDownIcon
                          style={
                            window.location.pathname === "/feedback"
                              ? {
                                  marginLeft: open ? "8px" : "-2px",
                                  marginRight: "30px",
                                  color: "white",
                                  fontSize: "25px",
                                }
                              : {
                                  marginLeft: "8px",
                                  marginRight: "30px",
                                  color: "#888",
                                }
                          }
                        />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: "18px",
                          fontFamily: "Campton Book",
                          fontWeight:
                            window.location.pathname === "/feedback"
                              ? "bold"
                              : "normal",
                          color:
                            window.location.pathname === "/feedback"
                              ? "white"
                              : "#888",
                        }}
                        primary={
                          VOCAB[state.auth.language]["pages"]["FEEDBACK"]
                        }
                      />
                    </ListItem>
                  </Tooltip>
                </Link>
              ) : (
                ""
              )}
              <Link to="/messenger">
                <Tooltip arrow title="Messenger" placement="right">
                  <ListItem
                    button
                    key="messenger"
                    style={
                      window.location.pathname === "/messenger"
                        ? open
                          ? {
                              backgroundColor: themeStyle.primaryColor,
                              borderRadius: "50px",
                              margin: "7.5px",
                              width: "93%",
                            }
                          : {
                              backgroundColor: themeStyle.primaryColor,
                              borderRadius: "50px",
                              margin: "7.5px",
                              width: "75%",
                            }
                        : {}
                    }
                  >
                    <ListItemIcon>
                      <MessageIcon
                        style={
                          window.location.pathname === "/messenger"
                            ? {
                                marginLeft: open ? "8px" : "-2px",
                                marginRight: "30px",
                                color: "white",
                                fontSize: "25px",
                              }
                            : {
                                marginLeft: "8px",
                                marginRight: "30px",
                                color: "#888",
                              }
                        }
                      />
                    </ListItemIcon>
                    <ListItemText
                      primaryTypographyProps={{
                        fontSize: "18px",
                        fontFamily: "Campton Book",
                        fontWeight:
                          window.location.pathname === "/messenger"
                            ? "bold"
                            : "normal",
                        color:
                          window.location.pathname === "/messenger"
                            ? "white"
                            : "#888",
                      }}
                      primary={VOCAB[state.auth.language]["pages"]["MESSENGER"]}
                    />
                  </ListItem>
                </Tooltip>
              </Link>
              <Link to="/settings">
                <Tooltip arrow title="Settings" placement="right">
                  <ListItem
                    button
                    key="settings"
                    style={
                      window.location.pathname === "/settings"
                        ? open
                          ? {
                              backgroundColor: themeStyle.primaryColor,
                              borderRadius: "50px",
                              margin: "7.5px",
                              width: "93%",
                            }
                          : {
                              backgroundColor: themeStyle.primaryColor,
                              borderRadius: "50px",
                              margin: "7.5px",
                              width: "75%",
                            }
                        : {}
                    }
                  >
                    <ListItemIcon>
                      <SettingsIcon
                        style={
                          window.location.pathname === "/settings"
                            ? {
                                marginLeft: open ? "8px" : "-2px",
                                marginRight: "30px",
                                color: "white",
                                fontSize: "25px",
                              }
                            : {
                                marginLeft: "8px",
                                marginRight: "30px",
                                color: "#888",
                              }
                        }
                      />
                    </ListItemIcon>
                    <ListItemText
                      primaryTypographyProps={{
                        fontSize: "18px",
                        fontFamily: "Campton Book",
                        fontWeight:
                          window.location.pathname === "/settings"
                            ? "bold"
                            : "normal",
                        color:
                          window.location.pathname === "/settings"
                            ? "white"
                            : "#888",
                      }}
                      primary={VOCAB[state.auth.language]["pages"]["SETTINGS"]}
                    />
                  </ListItem>
                </Tooltip>
              </Link>
            </List>
          </Drawer>
          {renderNotifications}
          {renderMenu}
        </div>
      );
    } else {
      return <Fragment></Fragment>;
    }
  } else {
    return <Fragment></Fragment>;
  }
}

export default Sidebar;
